module.exports = __webpack_public_path__ + "images/jdf-logo-green-md@1xa550f10c59d7ce4640f01015d399bc06.png";